import './index.css';
import { startFacilitiesTimetable } from './facilities-timetable/start';
import { startSessionsTimetable } from './sessions-timetable/start';

function start() {
  /* Currently this switching process relies on an env var, but it could also depend on something else like URL pattern
  matching, if one wanted to run sessions & facilities timetable on the same app (which seems reasonable as they have
  minimal server impact) */
  switch (process.env.REACT_APP_TIMETABLE_TYPE) {
    case 'sessions':
      startSessionsTimetable();
      return;
    case 'facilities':
      startFacilitiesTimetable();
      return;
    default:
      throw new Error(
        `Unrecognised value for required env var REACT_APP_TIMETABLE_TYPE: ${process.env.REACT_APP_TIMETABLE_TYPE}`
      );
  }
}

start();
